export function timeToHours(timeStr) {
    if (typeof timeStr === "number") return Number.isFinite(timeStr) && timeStr >= 0 ? timeStr : 0;
    if (typeof timeStr !== "string") return 0;

    const parts = timeStr.split(":");
    if (parts.length < 2) return 0;

    const hours = Number(parts[0]);
    const minutes = Number(parts[1]);

    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0;
    if (hours < 0 || minutes < 0 || minutes >= 60) return 0;

    return hours + minutes / 60;
}

export function formatHoursDE(hours) {
    if (typeof hours !== "number" || !Number.isFinite(hours)) return "";
    return hours.toFixed(2).replace(".", ",");
}

export function hoursToTime(hours) {
    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);
    return `${String(wholeHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function formatDateDE(dateStr) {
    if (typeof dateStr !== "string") return "";

    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return "";

    const [, year, month, day] = match;
    return `${day}.${month}.${year}`;
}

export function isOlderThan30Days(dateStr) {
    if (!dateStr) return false;

    const selected = new Date(dateStr);
    if (Number.isNaN(selected.getTime())) return false;

    const now = new Date();
    const diffMs = now - selected;
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays > 30;
}

export function isInFuture(dateStr) {
    if (!dateStr) return false;

    const selected = new Date(dateStr);
    if (Number.isNaN(selected.getTime())) return false;

    const today = new Date();
    today.setHours(23, 59, 59, 999);

    return selected > today;
}